export enum AlertMessage {
  Delete = "Are you sure you want to delete : ",
  isDraftSaved = "Navigating away may lead to losing your changes. Do you want to save these changes? Click 'Confirm' to save or 'Cancel' to continue",
  IdType = "Changing the source location will remove your current list of sources and any invalid processes for new source.",
  JobType = "Changing the Job type will remove your current list of sources and any invalid processes for new source.",
  OkWithWaterMark = "All Pre-air ProRes files are forensically watermarked for content protection.",
}
